// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

import angular from "angular";
import _ from "underscore";
import { Item } from "../models/item";
import { SummonCloudItem } from "../models/summonCloudItem";
import { Author } from "../models/author";
import { SummonAdditionalLink } from "../models/summonAdditionalLink";

class SummonUserService {
   $http: any
   $log: any
   $q: any
   $timeout: any
   authService: any
   saveSearchEndpoint: string
   saveItemEndpoint: string
   fire: any
   i18n: any
   savedSearchConfigs: any
   scope: any
   writeChains: { items: any, searches: any }
   writeSession: number
   constructor(configs: any, store: any, i18n: any, hooksService: any, $q: any, $http: any, $log: any, authService: any, $timeout: any) {
      this.init = this.init.bind(this)
      this.loginSuccessHandler = this.loginSuccessHandler.bind(this)
      this.logoutSuccessHandler = this.logoutSuccessHandler.bind(this)
      this.getFileId = this.getFileId.bind(this)
      this.getAllSearches = this.getAllSearches.bind(this)
      this.getFileContents = this.getFileContents.bind(this)
      this.writeToFile = this.writeToFile.bind(this)
      this.doWriteToFile = this.doWriteToFile.bind(this)
      this.createRequestsForData = this.createRequestsForData.bind(this)
      this.handleApiError = this.handleApiError.bind(this)
      this.createRequest = this.createRequest.bind(this)
      this.createAlwaysSuccessPromise = this.createAlwaysSuccessPromise.bind(this)
      this.waitOnAllPromises = this.waitOnAllPromises.bind(this)
      this.searchesResultCallback = this.searchesResultCallback.bind(this)
      this.itemsResultCallback = this.itemsResultCallback.bind(this)
      this.i18n = i18n
      this.$q = $q
      // Writes are queued per type so only one write (with its follow-up GET) is in flight
      // at a time; see writeToFile. writeSession is bumped on logout so a still-queued write
      // from a previous session aborts instead of running under a signed-out session.
      this.writeChains = { items: this.$q.resolve(), searches: this.$q.resolve() }
      this.writeSession = 0
      this.$http = $http
      this.$log = $log
      this.authService = authService
      this.$timeout = $timeout
      this.savedSearchConfigs = configs.data.savedSearchAndItems
      this.saveSearchEndpoint = '/save-search/'
      this.saveItemEndpoint = '/save-item/'
      this.scope = {
         name: 'Summon',
         fileId: 'dummy',
         providerDisplayName: '',
         userId: 'test_user',
         initialized: false,
         userDisplay: '',
         provider: '',
         tryAgainPromise: null,
         currentWriteId: 0,
         // these searches and items objects are a local cache that we use to determine how to send updates to server
         searches: [],
         items: []
      }

      hooksService.setHooks(this, 'SummonUserService', ['initSuccess', 'initFailed', 'signOut'])
   }

   init() {
      if (!this.savedSearchConfigs.providers.includes('summon')) {
         return
      }

      if (!this.savedSearchConfigs.searchEnabled && !this.savedSearchConfigs.itemsEnabled) {
         return
      }
      // now determine which authentication provider we support
      this.scope.provider = this.authService.getProviderForFeature('cloudStorage')
      this.scope.providerDisplayName = this.authService.scope.auth[this.scope.provider].displayName
      this.scope.canLoginManually = this.authService.scope.auth[this.scope.provider].canLoginManually
   }

   loginSuccessHandler(event: any, args: any) {
      let email
      if (!this.savedSearchConfigs.providers.includes('summon')) {
         return
      }
      if (!this.authService.providerSupportsFeature(args.provider, 'cloudStorage')) {
         return
      }

      this.scope.provider = args.provider

      this.scope.userId = this.authService.scope.auth[this.scope.provider].user

      // TODO - username is not updated in UI correctly, since sometimes user name is a second request _AFTER_ logging in...
      // This is cheating a bit, but it will probably work most of the time... if there is an @ sign, assume the userId is an email
      if (this.scope.userId.includes("@")) { email = this.scope.userId }
      this.scope.userDisplay = this.authService.scope.auth[this.scope.provider].username || email
      if (this.scope.userId) {
         this.scope.initialized = true
         return this.fire('initSuccess')
      } else {
         this.$log.error('No userId, cannot initialize Summon Cloud API')
         return this.fire('initFailed')
      }
   }

   logoutSuccessHandler(event: any, args: any) {
      if (args.provider !== this.scope.provider) {
         return
      }

      // remove save searches/items from local cache so a re-login starts from a clean slate
      this.scope.userId = ''
      this.scope.userDisplay = ''
      this.scope.searches = []
      this.scope.items = []
      this.scope.currentWriteId = 0
      // Invalidate any queued/in-flight write from this session: bump the session so a pending
      // write bails out in doWriteToFile (no requests, no cache repopulation under a signed-out
      // session), and start fresh write chains so the next session is not chained behind them.
      this.writeSession++
      this.writeChains = { items: this.$q.resolve(), searches: this.$q.resolve() }
      if (this.scope.tryAgainPromise) {
         this.$timeout.cancel(this.scope.tryAgainPromise)
         this.scope.tryAgainPromise = null
      }
      return this.fire('signOut')
   }

   // other services work with fileIds, but this doesn't, so return a dummy id
   getFileId(filename: any) {
      return this.$q.resolve(this.scope.fileId)
   }

   getAllSearches() {
      // createRequest with no arguments retrieves all saved searches (simple GET)
      return this.createRequest(this.saveSearchEndpoint)
         .then((results: any) => {
            this.scope.tryAgainPromise = null
            this.scope.searches = results.reverse() // we reverse it, since the UI expects the newest searches on top, but savedsearch outputs it old to new
            return { newSavedSearchesList: this.scope.searches}
         })
         .catch((err: any) => {
            // if we called this from writeToFile, we might have our internal cache @scope.searches out of sync
            // we schedule a task to call ourselves with a timeout of 10sec to try and fix it if it's an internal server error / temp problem
            // if it's a 401 or something we should not do this...
            if (err.status === 500) {
               if (this.scope.tryAgainPromise) {
                  this.$timeout.cancel(this.scope.tryAgainPromise)
               }
               this.scope.tryAgainPromise = this.$timeout((() => this.getAllSearches()), 10000)
               this.$log.debug('Error retrieving all searches, started a timer to retry in 10 seconds', err)
            }
            if ((err.status === 404) && (err.config.method === "GET")) {
               this.scope.searches = []
            }
            return []
         })
   }

   getAllItems(latestWriteId?: number) {
      // createRequest with no arguments retrieves all saved items (simple GET)
      return this.createRequest(this.saveItemEndpoint)
         .then((results: any) => {
            this.scope.tryAgainPromise = null
            if (latestWriteId === this.scope.currentWriteId) {
               this.scope.items = results
               return { newSavedItemsList : [...this.scope.items] }
            } else {
               return { writeInProgress: true}
            }
         })
         .catch((err: any) => {
            // if we called this from writeToFile, we might have our internal cache @scope.items out of sync
            // we schedule a task to call ourselves with a timeout of 10sec to try and fix it if it's an internal server error / temp problem
            // if it's a 401 or something we should not do this...
            if (err.status === 500) {
               if (this.scope.tryAgainPromise) {
                  this.$timeout.cancel(this.scope.tryAgainPromise)
               }
               this.scope.tryAgainPromise = this.$timeout((() => this.getAllItems(latestWriteId)), 10000)
               this.$log.debug('Error retrieving all items, started a timer to retry in 10 seconds', err)
            }
            if ((err.status === 404) && (err.config.method === "GET")) {
               this.scope.items = []
            }
            return []
         })
   }

   getFileContents(fileId: any, type: string) {
      if (type === 'searches') {
         return this.getAllSearches().then((res: any) => res.newSavedSearchesList || [])
      } else if ( type === 'items') {
         const latestWriteId = this.scope.currentWriteId
         return this.getAllItems(latestWriteId).then((res: any) => res.newSavedItemsList || [])
      }
   }

   writeToFile(data: any, _: any, type: string, isDelete: any) {
      // Serialize writes per type so overlapping rapid saves/deletes cannot race on the
      // single `currentWriteId` guard. Running one write (with its follow-up GET) at a time
      // makes each DELETE/POST settle before the next begins, so the final reconciling GET
      // reflects the true post-burst server state (fixes: delete 6 → UI 0 → save 1 → count 7).
      const key: 'items' | 'searches' = type === 'searches' ? 'searches' : 'items'
      // Reserve this write's generation id SYNCHRONOUSLY at enqueue time (items only — the id
      // guards getAllItems). During a burst every write bumps the id immediately, so only the
      // LAST-enqueued item write reconciles the cache; the intermediate writes get
      // {writeInProgress} from getAllItems and leave the optimistic UI untouched (prevents a
      // stale-state bounce, e.g. the list flashing 0 → 5 → 4 … as each delete's GET returns an
      // intermediate server snapshot). Bumping at execution time instead would defeat this,
      // because serialized writes never overlap and would each see latestWriteId === current.
      let latestWriteId: number | undefined
      if (key === 'items') {
         this.scope.currentWriteId++
         latestWriteId = this.scope.currentWriteId
      }
      const session = this.writeSession
      this.writeChains[key] = this.writeChains[key]
         .catch(() => {}) // a previously failed write must not break the queue
         .then(() => this.doWriteToFile(data, type, isDelete, latestWriteId, session))
      return this.writeChains[key]
   }

   doWriteToFile(data: any, type: string, isDelete: any, latestWriteId?: number, session?: number) {
      // A logout after this write was queued invalidates it: skip the requests and the cache
      // reconciliation so we never mutate state or hit the API under a signed-out session.
      if (session !== undefined && session !== this.writeSession) {
         return this.$q.resolve()
      }
      return this.createRequestsForData(data, type, isDelete)
         .then((results: any) => {
            if (type === 'searches') {
               return this.getAllSearches()
            } else if ( type === 'items') {
               return this.getAllItems(latestWriteId)
            }
         }).catch((results: any) => {
            // Resync the cache with the server, and WAIT for that GET to settle before the
            // write rejects, so the queue does not advance to the next write until this
            // write's reconciliation has completed (serialization must hold on failures too).
            const resync = type === 'searches'
               ? this.getAllSearches()
               : this.getAllItems(latestWriteId)
            return this.$q.resolve(resync)
               .catch(() => {}) // getAll* handle their own errors; never mask the write error
               .then(() => this.handleApiError(results.failed[0].original))
         })
   }

   createRequestsForData(data: any, type: any, deleted: any) {
      const requests: any[] = []
      const endpoint = type === 'searches' ? this.saveSearchEndpoint : this.saveItemEndpoint

      if(type === 'searches'){
         this.createRequestsForSearchData(data, deleted, requests, endpoint)
      } else if (type === 'items') {
         this.createRequestsForItemData(data, deleted, requests, endpoint)
      }
      return this.waitOnAllPromises(requests)
   }

   // The server supports
   // - GET - get all searches
   // - POST - save a new search
   // - PUT - update an existing one < this requires an ID part of body
   // - DELETE - remove a search < requires an ID as query param
   // this means we have to check what has changed in the data, and send the request(s)
   createRequestsForSearchData(data: any, deleted: any, requests: any, endpoint: string) {
      if (deleted) {
         if (deleted.id) { // if we have ID, just delete it
            requests.push(this.createRequest(endpoint, "DELETE", { id: deleted.id }))
         } else { // find the local cache one and get it's ID to delete
            const deletedFromCache = _.find(this.scope.searches, (s: any) => (s.name === deleted.name) && _.isEqual(s.params, deleted.params))
            requests.push(this.createRequest(endpoint, "DELETE", { id: deletedFromCache.id }))
         }
      } else {
         for (var search of ( data || [] )) {
            var userSearchObject = {
               name: search.name,
               params: search.params ? JSON.stringify(search.params) : ""
            }
            var existingSearch = _.find(this.scope.searches, (s: any) => s.id === search.id)
            if (existingSearch && (search.name !== existingSearch.name)) {  // it's an update / rename of the search, since it is in the list and the name is not equal
               requests.push(this.createRequest(endpoint, "PUT", { id: existingSearch.id, search: userSearchObject }))
            } else if (!existingSearch) {
               // we have no pre-existing searches, so post them
               requests.push(this.createRequest(endpoint, "POST", { search: userSearchObject }))
            }
         }
      }
   }

   // The save-item backend expects `editors` as a list of plain strings, but the
   // document presenter builds them as Contributor objects (the same way as `authors`).
   // Sending the objects raw causes a 400 (Cannot deserialize java.lang.String from Object).
   // Map each entry to its display name; values that are already strings pass through.
   contributorsToNames(list: any): string[] {
      // Normalize to an array first: `editors` is expected to be an array, but guard
      // against a single string/object (or null/undefined) so a bad shape can't throw
      // here and crash request creation.
      const arr = Array.isArray(list) ? list : (list == null ? [] : [list])
      return arr
         .map((c: any) => typeof c === 'string'
            ? c
            : (c && (c.fullname || [c.givenname, c.surname].filter(Boolean).join(' '))) || '')
         .filter((name: string) => !!name)
   }

   // The save-item backend types `secondaryResourceType` as a single String, but the
   // document model carries it as an array (the UI iterates it and uses .includes).
   // Collapse to a delimited string for the POST so the strict schema accepts it.
   arrayToScalarString(value: any): any {
      if (Array.isArray(value)) { return value.length ? value.join(',') : null }
      return value
   }

   // Inverse of arrayToScalarString, applied when restoring saved items so the value
   // returns to the array shape the UI expects. Empty/whitespace-only strings normalize
   // to null (not "") to avoid leaving a lingering scalar shape, and each part is trimmed.
   scalarStringToArray(value: any): any {
      if (typeof value === 'string') {
         const trimmed = value.trim()
         return trimmed.length
            ? trimmed.split(',').map((s: string) => s.trim()).filter(Boolean)
            : null
      }
      return value
   }

   createRequestsForItemData(data: Item[], deleted: any, requests: any, endpoint: string) {
      if (deleted && deleted.bookmark) { // if we have bookmark, just delete it, TODO:: anything needed for deleting from cache?
         requests.push(this.createRequest(endpoint, "DELETE", { bookmark: deleted.bookmark }))       
      } else {
         for (var item of ( data || [] )) {
            var userItemObject: SummonCloudItem = {
               hashKey: item.$$hashKey,
               _hasAltmetric: item._hasAltmetric,
               availabilityId: item.availability_id,
               authors: item.authors?.length ? 
                  item.authors.map((a: Author) => { return { fullname: a.fullname, givenname: a.givenname, surname: a.surname, hashKey: a.$$hashKey } })
                  : [],
               bookmark: item.bookmark,
               contentType: item.content_type,
               courseReserves: item.course_reserves,
               deweys: item.deweys ?? [],
               displayThumbnail: item.display_thumbnail,
               editions: item.editions ?? [],
               editors: this.contributorsToNames(item.editors),
               fullTitle: item.full_title,
               hasDetailPage: item.hasDetailPage,
               hasFullText: item.has_fulltext,
               id: item.id,
               index: item.index,
               isOpenAccess: item.is_open_access,
               isPeerReviewed: item.is_peer_reviewed,
               issues: item.issues ?? [],
               journalCoverageSummary: item.journalCoverageSummary,
               lcCallNumbers: item.lc_call_numbers ?? [],
               libguides: item.libguides ?? [],
               library: item.library,
               libraries: item.libraries ?? [],
               link: item.link,
               linkToPdf: item.link_to_pdf,
               proquestDocInsightsLink: item.proquest_doc_insights_link,
               meetingNames: item.meeting_names ?? [],
               pageCount: item.page_count,
               openAccessLink: item.open_access_link,
               openUrl: item.open_url,
               publicationDate: item.publication_date,
               publicationSeriesTitle: item.publication_series_title,
               publicationTitle: item.publication_title,
               publicationYears: item.publication_years ?? [],
               scopusCitedReferencesUrl: item.scopus_cited_references_url,
               scopusReferencesCount: item.scopus_references_count,
               secondaryResourceType: this.arrayToScalarString(item.secondary_resource_type),
               summonAdditionalLinks: item.summon_additional_links?.length ?
                  item.summon_additional_links.map((l: SummonAdditionalLink) => { return { databaseName: l.database_name, dbid: l.dbid, link: l.link, priority: l.priority, providerName: l.provider_name } })
                  : [],
               simpleTitle: item.simple_title,
               snippet: item.snippet,
               thumbnailSmall: item.thumbnail_small,
               volumes: item.volumes ?? [],
               webOfScience: {
                  referencesUrl: item.web_of_science?.references_url || "",
                  referencesCount: item.web_of_science?.references_count || 0
               },
            }
            var existingItem = _.find(this.scope.items, (s: any) => s.bookmark === item.bookmark)
            if (!existingItem) {
               requests.push(this.createRequest(endpoint, "POST", userItemObject))
            }
         }
      }
   }


   // use this to transform the response into a nice message which can be handled by code that uses this service.
   handleApiError(response: any) {
      const error = new Error()
      error.name = "Summon storage error"
      // Preserve the HTTP status so callers can distinguish permanent validation
      // failures (4xx) from transient/server errors (5xx, -1 network).
      ;(error as any).status = response?.status
      // A 500 (or any server crash) returns an HTML body instead of the expected JSON
      // envelope, so response.data is a string, not an object.  Accessing .description
      // or .error on it yields undefined, producing the misleading message
      // "undefined (undefined)".  Detect this early and fall back to a generic message.
      const dataIsJson = response?.data && typeof response.data === 'object'
      if (response?.status === -1) {
         // Network error — the request never got a usable response. Preserve the
         // special-case network message regardless of the (absent) body.
         error.message = this.i18n.translations.CLOUD_STORAGE_API_ERROR_NETWORK_ERROR
         return this.$q.reject(error)
      } else if (!dataIsJson) {
         // Non-JSON body (HTML 500 crash page, empty response, etc.) — server crash,
         // not a structured API error. Show a generic message and preserve the status.
         error.message = `Server error (HTTP ${response?.status})`
         this.$log.error(error)
         return this.$q.reject(error)
      } else if (response?.statusText == null && response?.error == null) { //TODO revise condition
         error.message = "Unknown"
         return this.$q.reject(error)
      } else if (response.data.description == "The search already exists") { //avoiding duplicate searches
         error.message = "duplicate"
         this.$log.error(error)
         return this.$q.reject(error)
      }
      //TODO this seems to be copied from microsoftApiService.ts, rewrite need it
      switch (response.data.description) {
         case 'cancelled':
         // override the message to make more sense for our users
            error.message = this.i18n.translations.CLOUD_STORAGE_AUTH_CANCELED
            break
         case 'invalid_session':
            error.message = this.i18n.translations.CLOUD_STORAGE_AUTH_ERROR
            break
         default:
            error.message = response.data.error + ' (' + response.data.description + ')'
      }

      this.$log.error(error)
      return this.$q.reject(error)
   }

   // helper functions below:

   searchesResultCallback(response: any) {
      if (response.status === 200) {
         if ((response.config.method === "GET") && response.data && angular.isArray(response.data)) {
            const searches = _.map(response.data, (d: any) => {
               // create a search object as the UI expects it from the response
               const search = {}
               // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{}'.
               search.id = d.id
               // @ts-expect-error TS(2339) FIXME: Property 'name' does not exist on type '{}'.
               search.name = d.search.searchName
               // @ts-expect-error TS(2339) FIXME: Property 'params' does not exist on type '{}'.
               search.params = {}
               if (d.search.parameters) {
                  try {
                     // @ts-expect-error TS(2339) FIXME: Property 'params' does not exist on type '{}'.
                     search.params = JSON.parse(d.search.parameters)
                  } catch (e) {
                     this.$log.debug('Could not parse search param as json, ignoring: ', d.search.parameters, e)
                  }
               }
               return search
            })
            return searches
         } else if ((response.config.method === 'POST') || (response.config.method === 'PUT')) {
            return {updated: response.data.id}
         } else {
            this.$log.debug('We got a non-error response, but cannot parse it... returning empty object ¯\_(ツ)_/¯', response)
            return {}
         }
      } else if ((response.status === 404) && (response.config.method === "GET")) {
         this.$log.debug('User has no saved searches yet, returning empty object')
         return {}
      } else if ((response.status === 404) && (response.config.method === "DELETE")) {
         // the search was already deleted — treat as success so duplicate cleanup can proceed
         this.$log.debug('Attempted to delete a search that was already gone, treating as success')
         return {}
      } else {
         return this.handleApiError(response)
      }
   }

   itemsResultCallback(response: any) {
      if (response.status === 200) {
         if ((response.config.method === "GET") && response.data && angular.isArray(response.data)) {
            const items = _.map(response.data, (d: SummonCloudItem) => {
               // create an item object as the UI expects it from the response
               const item: Item = {
                  $$hashKey: d.hashKey,
                  _hasAltmetric: d._hasAltmetric,
                  authors: d.authors.map((a: any) => { return { fullname: a.fullname, givenname: a.givenname, surname: a.surname, $$hashKey: a.hashKey }; }),
                  availability_id: d.availabilityId,
                  bookmark: d.bookmark,
                  content_type: d.contentType,
                  course_reserves: d.courseReserves,
                  deweys: d.deweys,
                  display_thumbnail: d.displayThumbnail,
                  editions: d.editions,
                  editors: d.editors,
                  full_title: d.fullTitle,
                  hasDetailPage: d.hasDetailPage,
                  has_fulltext: d.hasFullText,
                  id: d.id,
                  index: d.index,
                  is_open_access: d.isOpenAccess,
                  is_peer_reviewed: d.isPeerReviewed,
                  issues: d.issues,
                  journalCoverageSummary: d.journalCoverageSummary,
                  lc_call_numbers: d.lcCallNumbers,
                  libguides: d.libguides,
                  library: d.library,
                  libraries: d.libraries,
                  link: d.link,
                  link_to_pdf: d.linkToPdf,
                  proquest_doc_insights_link: d.proquestDocInsightsLink,
                  meeting_names: d.meetingNames,
                  open_access_link: d.openAccessLink,
                  open_url: d.openUrl,
                  page_count: d.pageCount,
                  publication_date: d.publicationDate,
                  publication_series_title: d.publicationSeriesTitle,
                  publication_title: d.publicationTitle,
                  publication_years: d.publicationYears,
                  scopus_cited_references_url: d.scopusCitedReferencesUrl,
                  scopus_references_count: d.scopusReferencesCount,
                  secondary_resource_type: this.scalarStringToArray(d.secondaryResourceType),
                  summon_additional_links: d.summonAdditionalLinks.map((l: any) => { return { database_name: l.databaseName, dbid: l.dbid, link: l.link, priority: l.priority, provider_name: l.providerName }; }),
                  simple_title: d.simpleTitle,
                  snippet: d.snippet,
                  thumbnail_small: d.thumbnailSmall,
                  volumes: d.volumes,
                  web_of_science: {
                     references_url: d.webOfScience.referencesUrl || undefined,
                     references_count: d.webOfScience.referencesCount || undefined
                  }
               }
              
               return item
            })
            return items
         } else if ((response.config.method === 'POST') || (response.config.method === 'PUT')) {
            return {updated: response.data.id}
         } else {
            this.$log.debug('We got a non-error response, but cannot parse it... returning empty object ¯\_(ツ)_/¯', response)
            return {}
         }
      } else if ((response.status === 404) && (response.config.method === "GET")) {
         this.$log.debug('User has no saved items yet, returning empty object')
         return {}
      } else if ((response.status === 404) && (response.config.method === "DELETE")) {
         // The item was already gone on the server (e.g. its original save had failed, or
         // it was removed elsewhere). Treat an idempotent delete as success so unchecking
         // it does not surface a spurious error.
         this.$log.debug('Attempted to delete a saved item that was already gone, treating as success')
         return {}
      } else {
         return this.handleApiError(response)
      }
   }

   createRequest(endpoint: string, method = 'GET', data?: any, params?: any){
      if (!this.scope.userId) {
         throw new Error(`cannot perform ${endpoint} request, no user available, please log in`)
      }
      const req = {
         method,
         url: endpoint + this.scope.userId,
         headers: {
            'Content-Type': 'application/json'
         }
      }

      // @ts-expect-error TS(2339) FIXME: Property 'data' does not exist on type '{ method: ... Remove this comment to see the full error message
      if (data) { req.data = data }
      // @ts-expect-error TS(2339) FIXME: Property 'params' does not exist on type '{ method... Remove this comment to see the full error message
      if (params) { req.params = params }

      // not sure why, but the @$http does not work with .catch, so handling status codes here in same callback
      const resultCallback = endpoint === this.saveSearchEndpoint ? this.searchesResultCallback : this.itemsResultCallback

      // not sure why, but the .catch does not work for $http...
      return this.$http(req).then(resultCallback)
   }


   // this is a wrapper that returns a promise that resolves, even if it was rejected.
   // made because further down the code uses $q.all() which returns immediately if one of the promises rejects.
   // using .all() for multiple cancel requests, where 1 of the request fails causes strange behavior, because the code will run without knowing which
   // items are resolved and which are not. This works around that by always resolving, and returning some extra data in the object that is returned.
   createAlwaysSuccessPromise(promise: any, id: any) {
      const deferred = this.$q.defer()
      promise.then(function(data: any) {
         const newData = {
            original: data,
            status: 'success',
            id
         }
         return deferred.resolve(newData)}).catch(function(err: any) {
         const newData = {
            original: err,
            status: 'error',
            id
         }
         return deferred.resolve(newData)
      })
      return deferred.promise
   }

   // this returns 1 single promise that resolves when all succeeded or rejects when one or more failed
   waitOnAllPromises(promises: any) {
      // @ts-ignore FIXME
      const allPromisesSuccess = _.map(promises, (promise: any) => this.createAlwaysSuccessPromise(promise))
      const deferred = this.$q.defer()
      this.$q.all(allPromisesSuccess).then((results: any) => {
         const allFailedPromises = _.filter(results, (result: any) => result.status !== 'success')
         if (allFailedPromises.length === 0) {
            return deferred.resolve({results})
         } else {
            return deferred.reject({results, failed: allFailedPromises})
         }
      })
      return deferred.promise
   }
}


SummonUserService.$inject = ['configService', 'storeService', 'translationService', 'hooksService', '$q', '$http', '$log', 'authenticationService', '$timeout']

angular.module('summonApp.services')
   .service('summonUserService', SummonUserService)
